<app-hero-redesign></app-hero-redesign>
<app-feature-section-redesign></app-feature-section-redesign>
<app-features-grid-redesign></app-features-grid-redesign>
<app-feature-section-alt-redesign></app-feature-section-alt-redesign>
<app-comparison-section-redesign></app-comparison-section-redesign>
<app-devices-section-redesign></app-devices-section-redesign>
<app-cta-section-redesign></app-cta-section-redesign>
<app-benefits-grid-redesign></app-benefits-grid-redesign>
<!-- <app-logo-showcase-redesign></app-logo-showcase-redesign> -->
<app-cta-banner-redesign></app-cta-banner-redesign>
<app-testimonials-redesign></app-testimonials-redesign>
